import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { CommonUtilitiesService } from "../common-utilities.service";
import { BalancesAndBoltonsService } from './balances-and-boltons.service';
import { constants } from '../constants';
import { FormGroup, FormBuilder, Validators, MaxLengthValidator } from '@angular/forms';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common'
import * as $ from "jquery";
declare var $: any;

@Component({
  selector: 'app-balances-and-boltons',
  templateUrl: './balances-and-boltons.component.html',
  styleUrls: ['./balances-and-boltons.component.scss']
})
export class BalancesAndBoltonsComponent implements OnInit {

  $owlElement: any;
  listLines: any;
  selectLine: any;
  balanceAndbolton: any;
  equipmentLine: any;
  boltonDetail: any;
  itemsdata: any;
  packages: any;
  test: boolean = true;
  testNumeroRatacion: number = 0;
  boltonDetailList: any[];
  boltonDetailListOtherDetails: any[];
  @ViewChild("myDiv") divView: ElementRef;
  @ViewChild("bottonBoltonDetail") bottonBoltonDetail: ElementRef;
  @ViewChild("panel") panel: ElementRef;
  event: MouseEvent;
  clientX = 0;
  clientY = 0;


  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  isBtnDisabled = false;
  isPackeageLoading = false;

    //Modal de recurrente
    isShowRecurrentModal = false;
    //Modal de cancelacionRecurrente
    isShowRecurrentCancelModal = false;
  
    isShowRecurrentCancelModalConfirmacion = false;
    recurrentCombo: any;
    findPaymentMethod: any;
    isEnableRecurrence = false;

  //Opciones modal tarifas
  isShowRatesModal = false;
  rateList = [];

  constructor(public LANG: CommonUtilitiesService, private balanceAndBoltonService: BalancesAndBoltonsService,
    private el: ElementRef,
    private formbuilder: FormBuilder,
    private renderer: Renderer2
  ) {
  }


  ngOnInit() {
    //obtiene las lineas de sesion
    let userData = JSON.parse(localStorage.getItem('userData'));
    this.listLines = userData;
    this.getRatesInfo();
    this.getRecurrenceConfig();
  }

  /**
   * Description: Método que obtiene la configuracion de encendido o apagado de recurrencia
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  getRecurrenceConfig(){
    this.isEnableRecurrence = false;
    this.balanceAndBoltonService.getRecurrenceEnableConfig().subscribe((valData => {
      if (valData['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE && valData["obj"] == constants.STRING_TRUE) {
        this.isEnableRecurrence = true;
      }
    }),
    (err) => {
      this.isEnableRecurrence = false;
    });
  }

  /**
   * Por cada linea seleccionada se inicializan en null las variables
   */

  initObjectBalancesAndBoltons() {
    this.balanceAndbolton = null;
    this.boltonDetail = null;
    this.itemsdata = null;
    this.packages = null;
    this.boltonDetailList = null;
    this.equipmentLine = null;
    this.boltonDetailList = [];
    this.boltonDetailListOtherDetails = [];
    this.restartCarousel();
  }


    /**
   * Consultar saldos luego de la cancelacion del combo recurrente
   */

  initObjectBalancesAndBoltonsCancelCombo() {
    this.balanceAndbolton = null;
    this.boltonDetail = null;
    this.itemsdata = null;
    this.packages = null;
    this.boltonDetailList = null;
    //this.equipmentLine = null;
    this.boltonDetailList = [];
    this.boltonDetailListOtherDetails = [];
    this.restartCarousel();
  }



  hideModal() {
    this.isShowModal = false;
  }




  /**
   * Obtiene la linea movil seleccionada en el combo de consultas
   * Inicializa las variables
   * @param newLineSelect 
   */
  onChangLine(newLineSelect) {
    this.initObjectBalancesAndBoltons();
    this.selectLine = newLineSelect;
    this.invokeBalancesAndBolton(this.selectLine.id, this.selectLine.mobileLine.subscriptionType, this.selectLine.mobileLine.tariffPlanIdCC);
    this.invokeEquipment(this.selectLine.id);
  }



  /**
   * Obtiene los saldos y los consumos luego de cancelar el combo recurrente
   */
  getBalanceAndBoltonLine() {
    this.initObjectBalancesAndBoltonsCancelCombo();
    this.invokeBalancesAndBolton(this.selectLine.id, this.selectLine.mobileLine.subscriptionType, this.selectLine.mobileLine.tariffPlanIdCC);
  }


  /**
   * Convierte todos los bonos de los difernetes tipos en un solo arreglo con el fin de poblar la tabla de saldos
   * 
   */
  fillBoltonList() {

    if (this.balanceAndbolton && this.balanceAndbolton.sumOfBoltonDTOList) {
      this.packages = this.balanceAndbolton.sumOfBoltonDTOList.map(z => z.boltonList).reduce(
        function (accumulator, currentValue) {
          return accumulator.concat(currentValue);
        }
      ).map(z => {
        if(z.showInTablePackages==true)
          return (z)
        return null;
        }
        ).filter( z =>   {
          return z != null;
        });
        
        this.balanceAndbolton.sumOfBoltonDTOList=this.balanceAndbolton.sumOfBoltonDTOList.filter(z => z.comboNotActive==false);

    

    }
  }

  /**
   * Invocacion al servicio que consulta los saldos
   * @param msisdn 
   * @param suscriptionType 
   * @param idPlan 
   */
  invokeBalancesAndBolton(msisdn: string, suscriptionType: string, idPlan: string) {
    this.isPackeageLoading = true;
    this.balanceAndBoltonService.getBalancesAndBolton(msisdn, suscriptionType, idPlan).subscribe((data => {
      this.isPackeageLoading = false;
      if (data['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
        this.balanceAndbolton = data['obj'];
        this.fillBoltonList();
      }
      else {
        this.isBtnDisabled = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('BALANCE_AND_LABEL_MODAL_ERROR_SENDING_REQUEST');
        this.isShowModal = true;
        this.fillBoltonList();
      }

    }),
      (err) => {
        this.isPackeageLoading = false;
        this.isBtnDisabled = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }


  /**
   * Invocacion al servicio que consula la informacion del equipo de linea
   * @param msisdn 
   */
  invokeEquipment(msisdn: string) {
    this.balanceAndBoltonService.getEquipment(msisdn).subscribe((data => {
      if (data['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
        this.equipmentLine = data['obj'];
      }
      else {
        this.isBtnDisabled = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('BALANCE_AND_LABEL_MODAL_ERROR_SENDING_REQUEST_EQUIP');
        this.isShowModal = true;
      }
    }

    ),
      (err) => { 
        this.isBtnDisabled = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }


  /**
   * obtiene el listado de bonos por tipo
   * @param balanceBolton 
   */
  boltonDetails(balanceBolton: any): any {
    this.enableCheckBolton();
    balanceBolton.disableQueryDetails = true;
    this.boltonDetailList = balanceBolton.boltonList.filter(x => {
      return x.detailsOthersCall == false;
    }
    );
    this.boltonDetailListOtherDetails = balanceBolton.boltonList.filter(x => x.detailsOthersCall == true);
    this.moveIconBalance();
  }



  /**
 * Habilitar el link para ver detalles
 * @param balanceBolton 
 */
  enableCheckBolton() {
    this.balanceAndbolton.sumOfBoltonDTOList.forEach(element => {
      element.disableQueryDetails = false;
    });

  }


  /**
   * Destruye el carousel 
   */
  restartCarousel() {
    $('#owl-carousell').owlCarousel('destroy');
  }



  /**
   * 
   * Inicializa el carousel
   */
  initOwlCarouselProperties() {
    $("#owl-carousell").owlCarousel
      ({
        stagePadding: 10,
        nav: false,
        dots: false,
        loop: false,
        rewind: true,
        margin: 50,
        autoplay: false,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1
          },
          576: {
            items: 1
          },
          768: {
            items: 2
          },
          992: {
            items: 4
          }
        }
      });
  }


  /**
   * Mueve el icono deacuerdo a la posicion indicada
   */
  moveIconBalance() {

    $('.item').on('click', function (event) {
      let positionCarousell: number = $("#owl-carousell").offset().left;
      //Si el evento generado es en ver detalle calcula la posicion del rombo
      if (event.target.innerText === 'Ver detalle') {
        let $this = $(this);
        $('.item').removeClass('clickeddddd');
        $(this).addClass('clickeddddd');

      }
    });



    $("#owl-carousell").bind('click dblclick mousedown mouseenter mouseleave', function () {
      let positionCarousell: number = $("#owl-carousell").offset().left;
      let tamanoCarousel: number = $(this).width();
      $('.clickeddddd').each(function () {
        let $this = $(this);
        let positionItem = $this.offset().left
        let resultado = positionItem + ($this.width() / 2) - positionCarousell;
        if (resultado <= 0) {
          let varrr = '0%';
          $('#panel').css('left', varrr);
        }
        else if (resultado >= tamanoCarousel) {
          let varrr = `100%`;
          $('#panel').css('left', varrr);
        }

        else {
          let varrr = `${String(resultado)}px`;
          $('#panel').css('left', varrr);
        }
      });


    });



  }



  /**
 * Porcentaje de consumo
 */
  percentConsumer(remainingBolton: number, configBolton: number) {
    let valueConsumer: number = Math.trunc((remainingBolton * 360) / configBolton) - 180;
   
    let resultt = `rotate(${valueConsumer}deg)`;
 
    return resultt;
  }





  /**
  * mostrar PaymentMethod del combo recurrente
  */
 showCombosRecurrentModal(bandera: any, recurrentCombo: any) {
  this.isShowRecurrentModal = true;
  this.recurrentCombo = recurrentCombo;
  if (this.findPaymentMethod) {
    this.findPaymentMethod = null;
  }
  this.balanceAndBoltonService.getPaymentMethodFavorita(this.recurrentCombo.favoritaSuscription.codeSuscription).subscribe((data => {
    if (data['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
      this.findPaymentMethod = data['obj'];
    }
    else {
      this.isBtnDisabled = false;
      this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
      this.modalContent = this.LANG.getLangText('MODEL_RECURRENT_ERROR_GET');
      this.isShowModal = true;
    }
  }
  ),
    (err) => {
      this.isBtnDisabled = false;
      this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
      this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
      this.isShowModal = true;
    });
}



/**
 * @description cancela el combo recurrente
 * @param  
 * @author Angel Marin
 */
cancelComboRecurrent() {
  this.balanceAndBoltonService.cancelComboRecurrentFavorita(this.recurrentCombo.favoritaSuscription.codeSuscription).subscribe((data => {
    if (data['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
      this.isBtnDisabled = false;
      this.modalTitle = this.LANG.getLangText('MODEL_RECURRENT_TITLE');
      this.modalContent = this.LANG.getLangText('MODEL_RECURRENT_CANCEL_COMBO_OK') +
        this.recurrentCombo.description +
        this.LANG.getLangText('MODEL_RECURRENT_CANCEL_COMBO_OK2');
      this.isShowRecurrentCancelModalConfirmacion = true;
      this.isShowRecurrentModal = false;
      this.getBalanceAndBoltonLine();
    } else {
      this.isBtnDisabled = false;
      this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
      this.modalContent = this.LANG.getLangText('MODEL_RECURRENT_CANCEL_ERROR');
      this.isShowModal = true;
    }
  }

  ),
    (err) => {
      this.isBtnDisabled = false;
      this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
      this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
      this.isShowModal = true;
    });

}

title: string
action: boolean
rowSelect: any
dataSources: any[] = [];
table: any;
isShowRecurrentBillingModal = false;

/**
 * @description Obtiene las facturas de la suscripcion recurrente
 * @author Angel Marin
 */
getInfoDataBilling() {
  
   this.isShowRecurrentBillingModal = true;
   this.balanceAndBoltonService.getBillingFavorita(this.recurrentCombo.favoritaSuscription.codeSuscription).subscribe((dataInfo => {
     this.dataSources = dataInfo['obj'];
     this.dataSources.
     forEach(function (element) {
        let datee = element.dateEmission.substring(0, 10);
        let dateParts = datee.split('/');
        let edatObject = new Date(dateParts[2], dateParts[1] - 1, +dateParts[0]);
        element.totalValue = parseInt(element.totalValue).toLocaleString('de-US', { style: 'currency', currency: 'USD' });
        element.totalValue = element.totalValue.replace('$', '').replace(' ', '')
        element.dateEmission = formatDate(new Date(edatObject), 'dd.MM.yyyy', 'en-US');
     });
     this.initConfGrid();
   }),
   (err) => {
     this.isBtnDisabled = false;
     this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
     this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_BILLING');
     this.isShowModal = true;
   });
}

/**
 * @description Inicializa el paginador de facturas
 * @author Angel Marin
 */
initConfGrid() {
  let noDataFoundText = this.LANG.getLangText('LABEL_NO_DATA_FOUND');
  this.table = $('#orders-table').DataTable({
    autoWidth: false,
    lengthChange: false,
    pageLength: 5,
    info: false,
    ordering: false,
    data: this.dataSources,
    retrieve: true,
    columns: [
      { title: 'CÓDIGO DOCUMENTO', data: 'codeDocument' },
      { title: 'FECHA DE EMISIÓN', data: 'dateEmission' },
      { title: 'VALOR', data: 'totalValue' },
      { title: 'PDF', defaultContent: "<div id='downloadBillingRow' class='c-violeta text-underline' style='text-decoration: underline; cursor: pointer'>Descargar</div>" }
    ],
    rowCallback: (row: Node, data: any[] | Object, index: number) => {
      $('#downloadBillingRow', row).unbind('click');
      $('#downloadBillingRow', row).bind('click', () => {
        this.downloadFormFile(data);
      });
      return row;
    }
    , language: {
      emptyTable: noDataFoundText
    }
  }
  );
  $('.dataTables_paginate').css('display', 'none');
}




/**
 * @description Ejecuta la descarga de la factura
 * @author Angel Marin
 * @param dataBilling
 */
downloadFormFile(dataBilling) {
  this.balanceAndBoltonService.getDocumentFormat(dataBilling).subscribe((data => {
    if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
      this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
      this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
      this.isShowModal = true;
      return false;
    }

    var fileToDownload:any = data["obj"];    
    if (this.LANG.detectIEEdge() > 0)  // If Internet Explorer
    {
      var blob = this.LANG.base64toBlob(fileToDownload,'file/pdf');
      window.navigator.msSaveOrOpenBlob(blob, constants.BALANCEANDBOLTON_DOWNLOAD_FILE_NAME +this.selectLine.id+'_'+
        dataBilling.dateEmission.replace('.', '').replace('.', '') +
        constants.BALANCEANDBOLTON_DOWNLOAD_FILE_NAME_2);
    }else{
      var url = constants.BASE64_PDF_FILE + fileToDownload;
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style.display = 'none';
      a.href = url;
  
      a.download = constants.BALANCEANDBOLTON_DOWNLOAD_FILE_NAME +this.selectLine.id+'_'+
        dataBilling.dateEmission.replace('.', '').replace('.', '') +
        constants.BALANCEANDBOLTON_DOWNLOAD_FILE_NAME_2;
      a.click();
      window.URL.revokeObjectURL(url);
    }   

  }),
    (err) => {
      this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
      this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
      this.isShowModal = true;
    });
}

  /**
    * Description: Método que formatea la cantidad de megas
    * Autor: Diego Diaz
    * @param num  numero a formatear
    * @return numero formateado
    */
	formatDecimals(num){
		return (!Number.isInteger(num)) ? parseFloat(num).toFixed(2) : num;
	}

  /////////////////////////////////////////(HU: Ver tarifas)//////////////////////////////////////////

  /**
    * Description: Método que muestra el modal de tarifas  (HU: Ver tarifas)
    * Autor: Diego Diaz
    * @param isShow true o false según si quiere o no mostrar el modal
    * @return N/A
    */
  showRatesModal(isShow) {
    this.isShowRatesModal = isShow;
  }

  /**
  * Description: Método que obtiene la información de tarifas  (HU: Ver tarifas)
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  getRatesInfo() {
    //ratesList se obitiene desde un ws
    this.balanceAndBoltonService.getRateList().subscribe((dataInfo => {
      if (dataInfo['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
        this.rateList = dataInfo['obj'];
      }
    }));
  }


}


